var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 661,
    viewBox: "0 0 1440 661",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3085_180421)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 660,
    transform: "translate(0 0.375)",
    fill: "#004469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1971.07 -596.659L1696.46 881.937L553.266 -95.1787L1971.07 -596.659Z",
    fill: "#033956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.84 -11.8506L-187.172 777.601L-230.853 -725.645L1092.84 -11.8506Z",
    fill: "#003552"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3085_180421"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 660,
    fill: "white",
    transform: "translate(0 0.375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg1.1a9332187fce9437f8b9381c2127344f.svg";
export { ForwardRef as ReactComponent };